import { useFormikContext } from 'formik';
import { FormikTextArea } from '@percihealth/react';

// The referrer's own notes on a referral form (PPL-3563): optional free text
// that stays inside Perci. Every organization's form shows this one field, so
// the promise made to the referrer reads the same everywhere — and it writes
// `notes.internal`, the shape every referral schema carries.
export const ReferralInternalNotesField = () => {
  const { values } = useFormikContext<{ notes?: { internal?: string } }>();

  return (
    <FormikTextArea
      id="notes.internal"
      name="notes.internal"
      className="full-width"
      label="Notes"
      description="These are internal only and will not be shared with the member"
      rows={5}
      // the field is always controlled, even on a form that seeded no notes
      value={values.notes?.internal ?? ''}
    />
  );
};
